import { useEffect } from "react";

const EscapeHandler = ({ func }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.keyCode === 27) {
        func()
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [])
}

export default EscapeHandler;